export const DEFAULT_SEC_TREE_ROOT = '20b3bb0a-6226-4cc7-9bcc-c9cb5c458f47';
